import React from "react";

/** Shared "Label + input" wrapper used across destination field-set components. */
export function Field({ label, required, children, hint, colSpan }) {
  return (
    <div className={colSpan === 2 ? "col-span-2" : ""}>
      <label className="label-mono">
        {label}
        {required ? "*" : ""}
      </label>
      {children}
      {hint && <div className="mt-1 text-[10px] text-zinc-500">{hint}</div>}
    </div>
  );
}

/** Standard `<input>` bound to the destination config bag. */
export function ConfigInput({
  name, config, setConfig, type = "text", placeholder, required, testId, mono = true, className = "",
}) {
  return (
    <input
      data-testid={testId}
      required={required}
      type={type}
      placeholder={placeholder}
      value={config[name] || ""}
      onChange={(e) => setConfig(name, e.target.value)}
      className={`w-full border border-black px-3 py-2 mt-1 ${mono ? "font-mono" : ""} ${className}`}
    />
  );
}
